import React from 'react';
import { Container } from 'reactstrap';
import { observer } from 'mobx-react';


const BrandBanner = function (props) {

    return (
        <div id="siteBanner" style={{ backgroundColor: "#F2EEE8", paddingTop: "1em", paddingBottom: "1em" }}>
            <Container>
                {props.store.bannerText && (<h1 className="h2" >{props.store.bannerText }</h1>) }
                {props.store.bannerSubtitle && (<h2 className="h5" style={{ color: "#808080" }} >{props.store.bannerSubtitle}</h2>)}
            </Container>
        </div>
    )
}

export default observer(BrandBanner);
